import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import React, { useEffect, useState } from "react";
import { getValue } from "@utils/lodash";
import { useNavigate } from "react-router-dom";
import NoAccessPage from "@components/common/NoAccess";

// import "entypo";

import "./index.scss";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import ScrollableReactTable from "@components/ScrollableDatatable";
import { QueryRequestHelper } from "@common/query-request-helper";
import { dashboardReimbursementHistory, dashboardReimbursementSummary, dashboardReimbursementToken } from "@services/dashboard.service";
import moment from "moment-timezone";
import Loader from "@components/common/Loader";

interface TableDataItem {
  id: string;
  reimbursement_name: string;
  eligibility: number;
  applied: number;
  approved: string | number;
  rejected: number;
  paid: string;
  balance: number;
  reimbursement_code?: string;
  template?: string;

}


function ReimbursementDashboard(props: any) {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const urlParams = Object.fromEntries(urlSearchParams.entries());
  const navigate = useNavigate();
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [currentActiveTab, setCurrentActiveTab] = useState("1");
  const [dashboardToken, setDashboardToken] = useState<string | undefined>();
  const [dashboardData, setDashboardData] = useState([]);
  const [tableData, setTableData] = useState<TableDataItem[]>([]);
  const [dashboardHistoryData, setDashboardHistoryData] = useState([]);

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */
  useEffect(() => {
      getTokenData();
  }, []);

  useEffect(() => {
    if (Object.keys(urlParams).length > 0 && props.permissionAPITriggered) {
      getTokenData();
    }
  }, [window.location.href, props.permissionAPITriggered]);

  // Add an effect that watches for the token and calls getSummaryData when the token changes
  useEffect(() => {
    if (dashboardToken) {
      getSummaryData();
      getHistoryData();
    }
  }, [dashboardToken]);

  // Toggle active state for Tab
  const toggle = (tab: any) => {
    if (currentActiveTab !== tab) setCurrentActiveTab(tab);
  };

  // const getTokenData = async () => {
  //   try {
  //     let payload = {
  //       unique_id: "NnRz5JGyRkN3csPvHdE03w==",
  //       password: "BKwULG1VqRc3IPImFbwiqQ==",
  //       service_id: "CFFg8aGmOxNKbKF0RExH+Q==",
  //       ecode: "1042415"
  //     };
  //     let userResponse = await dashboardReimbursementToken(payload);
  //     if (userResponse) {
  //       setDashboardToken(getValue(userResponse, `data.token`, ""));
  //     } else {
  //       setIsLoading(false);
  //     }
  //   } catch (error) {
  //     setIsLoading(false);
  //   }
  // };

  const getTokenData = async () => {
    try {
      // Check if token exists in localStorage and is not expired
      // const storedTokenData = localStorage.getItem("stohrmToken");
      // const tokenTimestamp = localStorage.getItem("stohrmTokenTimestamp");
      
      // if (storedTokenData && tokenTimestamp) {
      //   const currentTime = new Date().getTime();
      //   const storedTime = parseInt(tokenTimestamp);
      //   const fifteenMinutes = 15 * 60 * 1000; // 15 minutes in milliseconds
        
      //   // If token is not expired (less than 15 minutes old), use it
      //   if (currentTime - storedTime < fifteenMinutes) {
      //     setDashboardToken(storedTokenData);
      //     return;
      //   }
      // }
  
      // If no valid token in storage, fetch a new one
      let payload = {
        unique_id: "NnRz5JGyRkN3csPvHdE03w==",
        password: "BKwULG1VqRc3IPImFbwiqQ==",
        service_id: "CFFg8aGmOxNKbKF0RExH+Q==",
        ecode: "1042415"
      };
  
      let userResponse = await dashboardReimbursementToken(payload);
      
      if (userResponse) {
        const token = getValue(userResponse, `data.token`, "");
        if (token) {
          // Store the new token and current timestamp
          localStorage.setItem("stohrmToken", token);
          localStorage.setItem("stohrmTokenTimestamp", new Date().getTime().toString());
          setDashboardToken(token);
        } else {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching token:", error);
      setIsLoading(false);
      // Clear invalid token data if there's an error
      localStorage.removeItem("stohrmToken");
      localStorage.removeItem("stohrmTokenTimestamp");
    }
  };  

  // const getSummaryData = async () => {
  //   try {
  //     setIsLoading(true);
  //     let payload = {
  //       token: dashboardToken,
  //     };

  //     let userResponse = await dashboardReimbursementSummary(payload);
  //     if (userResponse) {
  //       const reimbursementTypes = getValue(userResponse, `data.reimbursement_types`, {});
  //       setDashboardData(reimbursementTypes);

  //       const transformedData = Object.entries(reimbursementTypes).map(([key, item]:any) => ({
  //         id: key, // Using the key (like "FUEMAI") as id
  //         reimbursement_name: item.reimbursement_name,
  //         eligibility: item.quaterly_amount,
  //         applied: item.applied,
  //         approved: item.approved,
  //         rejected: item.rejected,
  //         paid: item.paid,
  //         balance: item.balance,
  //         reimbursement_code: item.reimbursement_code || key, // Using item's reimbursement_code or key as fallback
  //         template: item.template || 'default' // Using item's template or 'default' as fallback
  //       }));
        
  //       setTableData(transformedData);
  //       setIsLoading(false);
  //     } else {
  //       setIsLoading(false);
  //     }
  //   } catch (error) {
  //     setIsLoading(false);
  //   }
  // };


  const getSummaryData = async () => {
    try {
      setIsLoading(true);
      let payload = { token: dashboardToken };
      let userResponse = await dashboardReimbursementSummary(payload);
      if (userResponse) {
        const reimbursementTypes = getValue(userResponse, `data.reimbursement_types`, {});
        setDashboardData(reimbursementTypes);
  
        const transformedData = Object.entries(reimbursementTypes).map(([key, item]: any) => ({
          id: key,
          reimbursement_name: item.reimbursement_name,
          eligibility: item.quaterly_amount,
          applied: item.applied,
          approved: item.approved,
          rejected: item.rejected,
          paid: item.paid,
          balance: item.balance,
          reimbursement_code: item.reimbursement_code || key,
          template: item.template || 'default',
        }));
  
        setTableData(transformedData);
      }
    } catch (error) {
      console.error("Error fetching summary data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  
  const getHistoryData = async () => {
    try {
      setIsLoading(true);
      let payload = {
        token: dashboardToken,
      };

      let userResponse = await dashboardReimbursementHistory(payload);
      if (userResponse) {
        setDashboardHistoryData(getValue(userResponse, `data`, []));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };


  const handleActionClick = (row: TableDataItem) => {
    navigate(`/reimbursement/edit?reimbursement_code=${row.reimbursement_code}&template=${row.template}`);
  };
  
    

  
  /* ------------------- Columns Data ----------------------------------------- */
  const summaryColumns = React.useMemo(
    () => [
      {
        Header: "Type",
        accessor: "reimbursement_name",
        style: { "white-space": "unset", overflow: "hidden" },
        width: 250,
      },
      {
        Header: "Eligibility",
        accessor: "eligibility",
        style: { "white-space": "unset" },
        width: 120,
      },
      {
        Header: "Applied",
        accessor: "applied",
        style: { "white-space": "unset" },
        width: 120,
      },
      {
        Header: "Approved",
        accessor: "approved", // Fixed this from accesslevel to approved
        style: { "white-space": "unset" },
        width: 120,
      },
      {
        Header: "Rejected",
        accessor: "rejected",
        style: { "white-space": "unset" },
        width: 120,
      },
      {
        Header: "Paid",
        accessor: "paid",
        style: { "white-space": "unset" },
        width: 120,
      },
      {
        Header: "Balance",
        accessor: "balance",
        style: { "white-space": "unset" },
        width: 150,
      },
      {
        Header: "Action",
        id: "action",
        width: 100,
        Cell: ({ row }: any) => (
          <>
          <button
            className="btn btn-primary"
            onClick={(e) => {
              e.stopPropagation(); // Prevent row click event
              console.log("Row data:", row); // Log the row object
              // handleActionClick(row.original.reimbursement_code,row.original.template);
              handleActionClick(row.original);
            }}
          >
            Edit
          </button>
          </>
        ),
      }
    ],
    []
  );

  const historyColumns = React.useMemo(
    () => [
      {
        Header: "AppIn No.",
        accessor: "register_id",
        style: { "white-space": "unset", overflow: "hidden" },
        width: 200,
        Cell: ({ row }: any) => (
          <NavLink
            to={`/reimbursement/view`}
            style={{ textDecoration: "none", color: "blue" }}
          >
            {row.original.register_id}
          </NavLink>
        ),
      },
      {
        Header: "Type",
        accessor: "reimbursement_name",
        style: { "white-space": "unset" },
        width: 250,
      },
      {
        Header: "Date",
        accessor: "applied_date",
        style: { "white-space": "unset" },
        width: 180,
      },
      {
        Header: "Amount",
        accessor: "approved_amount",
        style: { "white-space": "unset" },
        width: 180,
      },
      {
        Header: "Status",
        accessor: "app_status",
        style: { "white-space": "unset" },
        width: 180,
      },
    ],
    []
  );


  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      tableData.length > 0
        ? tableData.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };
  const rowClick = (obj: object) => {
    // navigate(`/reimbursement/view`);
  };

  const rowClickHistory = (obj: object) => {
    // console.log("obj", getValue(obj, `original.register_id`, ""));
    navigate(`/reimbursement/view/${getValue(obj, `original.register_id`, "")}`);
  };

  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: {
          //   background:  'red',
          //   color: 'black'
        },
      };
    }
    return {};
  };

  console.log(getValue(props, `subTabPermissionList`, []), "subTabPermissionList");
  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes("reimbursement_dashboard") ? (
        <NoAccessPage />
      ) : (
        <>
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <h4 className="dashbaord-wrapper__header-title">
              Reimbursement Dashboard
            </h4>
          </div>
          <div className="reimbursement-dashbaord-wrapper_section_container">
            {isLoading || !props.permissionAPITriggered ? (
              <Loader />
            ) : (
            <>
              <div className="stats-wrapper">
                <div className="d-flex gap-3 stats-wrap-card-gap">
                  <div className="stats-card tile-blue">
                    <div className="count-holder">4</div>
                    <div className="card-title">Applications</div>
                    <div className="image-holder">
                      {/* <span className="entypo entypo-database"></span> */}
                    </div>
                  </div>

                  <div className="stats-card tile-cyan">
                    <div className="count-holder">0</div>
                    <div className="card-title">Approved</div>
                    <div className="image-holder"></div>
                  </div>

                  <div className="stats-card tile-red">
                    <div className="count-holder">0</div>
                    <div className="card-title">Rejected</div>
                    <div className="image-holder"></div>
                  </div>

                  <div className="stats-card tile-orange">
                    <div className="count-holder">4</div>
                    <div className="card-title">Waiting</div>
                    <div className="image-holder"></div>
                  </div>
                </div>
              </div>

              <div className="summary-history-tabs-wrapper mt-4">
                <div>
                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: currentActiveTab === "1",
                        })}
                        onClick={() => {
                          toggle("1");
                        }}
                      >
                        Summary
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: currentActiveTab === "2",
                        })}
                        onClick={() => {
                          toggle("2");
                        }}
                      >
                        History
                      </NavLink>
                    </NavItem>
                  </Nav>

                  <TabContent activeTab={currentActiveTab}>
                    <TabPane tabId="1">
                      <ScrollableReactTable
                        columns={summaryColumns}
                        data={tableData}
                        getTableState={getTableState}
                        rowClick={rowClick}
                        checkboxlogo
                        selectedIDs={selectedIDs}
                        getTrProps={getTrProps}
                      />
                    </TabPane>
                    <TabPane tabId="2">
                      <ScrollableReactTable
                        columns={historyColumns}
                        data={dashboardHistoryData}
                        getTableState={getTableState}
                        rowClick={rowClickHistory}
                        checkboxlogo
                        selectedIDs={selectedIDs}
                        getTrProps={getTrProps}
                      />
                    </TabPane>
                  </TabContent>
                </div>
              </div>
            </>
            )}
          </div>
        </>
      )}
    </DashboardLayout>
  );
}

export default ReimbursementDashboard;